import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function useKioskAutoHome(timeoutMs = 60000) {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname === '/') return undefined

    let timer

    const resetTimer = () => {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        navigate('/', { replace: true })
      }, timeoutMs)
    }

    const events = ['click', 'touchstart', 'keydown', 'mousemove']
    events.forEach((eventName) => window.addEventListener(eventName, resetTimer))
    resetTimer()

    return () => {
      window.clearTimeout(timer)
      events.forEach((eventName) => window.removeEventListener(eventName, resetTimer))
    }
  }, [location.pathname, navigate, timeoutMs])
}
